const DAY_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

const DEFAULT_CHANGEOVER = 'any';
const DEFAULT_AVAILABILITY = 'available';

const parseChangeoverTemplate = raw => {
  let parsed = raw;

  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed);
      if (typeof parsed === 'string') parsed = JSON.parse(parsed);
    } catch (error) {
      return null;
    }
  }

  if (!Array.isArray(parsed)) return null;

  const byDay = {};
  parsed.forEach(entry => {
    if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return;
    if (typeof entry.day !== 'string') return;
    byDay[entry.day] = entry;
  });

  return byDay;
};

// Precedence matches the backend: per-date entry, then weekday rule, then `default`
const resolveChangeoverForDay = (
  defaultAvailability,
  availabilityCalendar,
  day
) => {
  const template = parseChangeoverTemplate(defaultAvailability) || {};
  const fallback = template.default || {};
  const weekday = template[DAY_NAMES[day.day()]] || fallback;
  const override = (availabilityCalendar || {})[day.format('DD-MM-YYYY')] || {};

  return {
    availability:
      override.availability ||
      weekday.availability ||
      fallback.availability ||
      DEFAULT_AVAILABILITY,
    changeover:
      override.changeover ||
      weekday.changeover ||
      fallback.changeover ||
      DEFAULT_CHANGEOVER
  };
};

// A rule that only permits the other end of the stay blocks this end; `none` blocks both
const isChangeoverBlocked = (changeover, focusedInput) => {
  if (changeover === 'none') return true;
  if (focusedInput === 'startDate') return changeover === 'check_out';
  if (focusedInput === 'endDate') return changeover === 'check_in';
  return false;
};

module.exports = resolveChangeoverForDay;
module.exports.resolveChangeoverForDay = resolveChangeoverForDay;
module.exports.isChangeoverBlocked = isChangeoverBlocked;
module.exports.parseChangeoverTemplate = parseChangeoverTemplate;
module.exports.DAY_NAMES = DAY_NAMES;
